export default "__VITE_ASSET__Ddg4PARn__"